import { categoryEmojiMap } from '../data/shared/utils/CategoryEmojiMap';
import { formatSpendCategory } from '../data/shared/utils/formatSpendCategory';
import { Modal } from './design-system/Modal';
import _ from 'lodash';
import { useBestEarnRates } from '../data/shared/hooks/useBestEarnRates';
import { CardRewardsEarnRates, EarnRateInfo } from 'data/types/CardRewardsEarnRates';
import { CardData } from 'data/types/CardData';
import { formatRewardsType } from '../data/shared/utils/formatRewardsType';
import { useCardModal } from '../hooks/useCardModal';
import { formatEarnRate } from '../data/shared/utils/formatEarnRate';
import { TableCellWithSubtext } from './design-system/TableCellWithSubtext';
import { CreditCard } from 'data/shared/CreditCard';
import { CreditCardData } from 'data/shared/CreditCardData';
import { CardButton } from './design-system/CardButton';
import { TableCardButton } from './TableCardButton';
export const CategoryModal = ({
  handleClose,
  cards,
  monthlySpend,
  category,
  pointValues,
}: {
  category: string;
  cards: CreditCard[];
  monthlySpend: CardRewardsEarnRates;
  handleClose: () => void;
  pointValues: Record<string, number>;
}) => {
  const bestEarnRates = useBestEarnRates(cards, monthlySpend, pointValues, false);
  const [cardModal, setShowCardModal] = useCardModal();

  const maybeBestCardInfo = _.get(bestEarnRates, category)?.[0];
  if (!maybeBestCardInfo) {
    return null;
  }
  const { card, ...bestCardInfo }: CardData & { card: CreditCard } = maybeBestCardInfo
  const { earnRate } = _.get(bestEarnRates, category)?.[0];
  const { rewardsType } = bestCardInfo;

  return (
    <Modal handleClose={handleClose} isOpen={true}>
      {cardModal}
      <h2>
        {categoryEmojiMap[category]} {formatSpendCategory(category)}
      </h2>

      {/* TODO: implement */}
      <h3>Your best card</h3>
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <div style={{ maxWidth: 120 }}>
          <TableCellWithSubtext
            text={formatEarnRate(earnRate, rewardsType)}
            subText={formatRewardsType(rewardsType)}
          />
        </div>
        <button
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            alignItems: 'center',
            padding: 8,
            marginLeft: 8,
          }}
          onClick={() => setShowCardModal(card)}
        >
          <img
            src={`cards/${CreditCardData[card].imageName}`}
            alt={CreditCardData[card].name}
            style={{
              width: 80,
              maxHeight: 60,
              boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
              marginRight: 10,
            }}
          />
          <p style={{ lineHeight: 1.1 }}>
            <strong>{CreditCardData[card].name}</strong>
          </p>
        </button>
      </div>

      <p>
        Based on your point value for{' '}
        {formatRewardsType(rewardsType)}, monthly spend, and
        currently selected cards.
      </p>
      {/* TODO: Choose a different card instead */}
      {/* {_.get(bestEarnRates, category)?.length > 1 && (
        <>
          <h3>Other great cards for {categoryEmojiMap[category]}{' '}{formatSpendCategory(category)}</h3>
          <div style={{ margin: '10px -10px 0 -10px' }}>
            {_.get(bestEarnRates, category)?.map((cardInfo: EarnRateInfo) => (
                <div
                style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
              >
                <div style={{ maxWidth: 120 }}>
                  <TableCellWithSubtext
                    text={formatEarnRate(cardInfo.earnRate, cardInfo.rewardsType)}
                    subText={formatRewardsType(cardInfo.rewardsType)}
                  />
                </div>
                <TableCardButton
                  key={cardInfo.card}
                  cardData={CreditCardData[cardInfo.card]}
                  onClick={() => setShowCardModal(cardInfo.card)}
                />
              </div>
            ))}
          </div>
        </>
      )} */}
    </Modal>
  );
};
